import { initVueApp } from './scripts/vue-app';
export const VueApp = initVueApp();

// the loading spinner in wizard.html.twig is a lottie animation - common.js, which usually starts it, is not part of this entry
import * as lottieAnimation from './scripts/lottie-animation';
lottieAnimation.init();
